import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3da1ca88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "saved-survey-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " Encuesta guardada con éxito ", -1))

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'SavedSurvey',
  setup(__props) {

const router = useRouter()

function newSurvey() {
    router.push({ name: 'home' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_btn, {
      color: "primary",
      onClick: newSurvey,
      "prepend-icon": "mdi-plus"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Agregar nueva encuesta ")
      ]),
      _: 1
    })
  ]))
}
}

})